// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"419":"css/admin-app.6791","8741":"css/app.6791"}[chunkId] + ".css";
};